// Per-conversation Q&A hide state.
//
// Each conversation has its own boolean: when true, all `content.kind === 'qa'`
// messages are filtered out of the chat list AND the Ask Tom input is
// replaced by an "Unhide question & answer chat." button. When false (the
// default), Q&A messages render inline with generation messages and the
// input is visible.
//
// Persisted in localStorage so reloading the editor doesn't lose the
// hide preference. Failures are silently swallowed — localStorage being
// unavailable (incognito, quota) is not fatal for the rest of the UI.

const KEY_PREFIX = 'telekinesis:qaHidden:';

export function isQaHidden(conversationId: string): boolean {
  if (!conversationId) return false;
  try {
    return localStorage.getItem(KEY_PREFIX + conversationId) === '1';
  } catch {
    return false;
  }
}

export function setQaHidden(conversationId: string, hidden: boolean): void {
  if (!conversationId) return;
  try {
    if (hidden) {
      localStorage.setItem(KEY_PREFIX + conversationId, '1');
    } else {
      localStorage.removeItem(KEY_PREFIX + conversationId);
    }
  } catch {
    /* localStorage unavailable; no-op. */
  }
}
